'use client';
import { Box, Typography } from '@mui/material';

import { useT } from '@/hooks';

interface NoEarningsProps {
  variant?: 'mobile' | 'desktop';
}

export const NoEarnings = ({ variant = 'desktop' }: NoEarningsProps) => {
  const { t } = useT();
  const isMobile = variant === 'mobile';

  if (isMobile) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3, py: 1 }}>
        <Box
          sx={{
            width: 24,
            height: 24,
            borderRadius: '50%',
            bgcolor: 'action.hover',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          <Typography sx={{ fontSize: '0.875rem', color: 'text.disabled', fontWeight: 500 }}>
            $
          </Typography>
        </Box>
        <Typography sx={{ fontSize: '0.875rem', color: 'text.secondary', fontWeight: 500 }}>
          {t('earnings.noEarnings')}
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ textAlign: 'center', py: 4 }}>
      <Box
        sx={{
          width: 48,
          height: 48,
          borderRadius: '50%',
          bgcolor: 'action.hover',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mx: 'auto',
          mb: 2,
        }}
      >
        <Typography sx={{ fontSize: '1.5rem', color: 'text.disabled' }}>$</Typography>
      </Box>
      <Typography sx={{ fontSize: '0.875rem', color: 'text.secondary', fontWeight: 500 }}>
        {t('earnings.noEarnings')}
      </Typography>
    </Box>
  );
};
